import { call, put, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { reset as resetForm } from 'redux-form'
import {
  add as addList
} from '../redux/lists'
import {
  addList as addListToView
} from '../redux/view'

export default function * requestAddList (action) {
  const { name, index } = action.payload

  const tempId = `temp-${new Date().getTime()}`

  const state = yield select()

  const vBoardId = state['view-myboard'].view.id

  yield put(resetForm('addListForm'))

  const optimisticAction = yield optimisticPut(addList({
    id: tempId,
    name,
    isBusy: true,
    isLoaded: true
  }))
  const optimisticAction2 = yield optimisticPut(addListToView({
    id: tempId,
    index
  }))

  try {
    yield call(apiAction, 'AddVList', {
      vBoardId,
      name
    })
  } finally {
    yield optimisticAction2.revert()
    yield optimisticAction.revert()
  }
}
